import React from "react";
import firebase from "./Firebase";
import ProgressBar from "react-bootstrap/ProgressBar";
import Image from "react-bootstrap/Image";
import { Container, Row, Col } from "reactstrap";
import mySvg from "./larva.png";
import { TiCloudStorageOutline } from "react-icons/ti";
import FormFilled from "./FormFilled";
import FormError from "./FormError";

class UploadImages extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      images: [],
      predicted_images: [],
      raw_images: [],
      raw_image_link: "",
      predicted: false,
      show: false,
      show1: false,
      predicted_image_link: "",
      raw_image_name: "",
      progress: 0,
      user: null,
      classifications: [],
      probabilities: [],
      orig_names: [],
    };
    this.getClassifiedImage = this.getClassifiedImage.bind(this);
  }

  random_name_generator() {
    let characters =
      "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
    let result = "";
    let length = 16; // Customize the length here.
    for (let i = length; i > 0; --i)
      result += characters[Math.round(Math.random() * (characters.length - 1))];
    // console.log("Name: ", result)
    return result;
  }

  handleChange = (e) => {
    let imagesList = [];
    for (let i = 0; i < e.target.files.length; i++) {
      if (e.target.files[i]) {
        imagesList.push(e.target.files[i]);
        this.setState(() => ({ images: imagesList }));
      }
    }
    // console.log(imagesList[0], imagesList[1]);
  };

  handleUpload = () => {
    const { images } = this.state;
    console.log("Images", images);
    var usr = firebase.auth().currentUser.email;
    usr = usr.split("@")[0];
    // console.log(usr);
    // this.setState({user: usr});
    if (images.length === 0) {
      alert("Images are not chosen.");
      return false;
    } else if (images.length > 5) {
      alert("You can upload maximum 5 images at a time.");
      return false;
    }
    for (let i = 0; i < images.length; i++) {
      let name_file = this.random_name_generator();
      name_file = name_file.toString() + ".jpg";
      const uploadTask = firebase
        .storage()
        .ref(`raw_images/${usr}/${name_file}`)
        .put(images[i]);
      const ref = firebase.database().ref(`raw_images/`);
      uploadTask.on(
        "state_changed",
        (snapshot) => {
          const progress = Math.round(
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100
          );
          this.setState({ progress });
        },
        (error) => {
          alert("Image Upload was not successful");
          console.log(error);
        },
        () => {
          firebase
            .storage()
            .ref("raw_images/" + usr)
            .child(name_file)
            .getDownloadURL()
            .then((url) => {
              // console.log("URL FOR RAW: " + url);
              ref.push({
                by_usr: usr,
                predicted: false,
                raw_image_link: url,
                predicted_image_link: "",
                raw_image_name: usr + "_" + name_file,
                original_name: images[i].name,
              });
            });
          console.log("Image Uploaded");
        }
      );
    }
    this.setState({
      show: !this.state.show,
      show1: !this.state.show1,
    });
    alert(`${images.length} images will be uploaded. `);
  }; //end upload handler function

  getClassifiedImage() {
    const { images } = this.state;
    var usr = firebase.auth().currentUser.email;
    usr = usr.split("@")[0];
    console.log("get classified images", images);
    // query firebase by raw_image_name
    var ref = firebase.database().ref(`raw_images/`);
    // query ones that contain usr in raw_image_name
    ref
      .orderByChild("by_usr")
      .equalTo(usr)
      .on(
        "value",
        (data) => {
          // console.log("Logging data.val()", data.val());
          var classified = data.val();
          var keys = Object.keys(classified);
          console.log("Classified", classified);
          let predicted_ones = [];
          let raw_ones = [];
          let cl_list = [];
          let prob_list = [];
          let names_list = [];
          for (
            let i = keys.length - 1;
            i > keys.length - 1 - images.length;
            i--
          ) {
            var k = keys[i];
            var raw_image = classified[k].raw_image_link;
            var predicted_image = classified[k].predicted_image_link;
            var cl = classified[k].predicted_class;
            var prob = classified[k].predicted_probability;
            var n = classified[k].original_name;
            // console.log(predicted_image);
            if (predicted_image !== null) {
              predicted_ones.push(predicted_image);
            }
            if (raw_image !== null) {
              raw_ones.push(raw_image);
            }
            if (cl !== null) {
              cl_list.push(cl);
            }
            if (prob !== null) {
              prob_list.push(prob);
            }
            if (n !== null) {
              names_list.push(n);
            }

            // sort all lists by original name
            var zipped = [];
            for (var m = 0; m < names_list.length; m++) {
              zipped.push([names_list[m], predicted_ones[m], raw_ones[m], cl_list[m], prob_list[m]]);
            }
            zipped.sort();
            for (var l = 0; l < zipped.length; l++) {
              names_list[l] = zipped[l][0];
              predicted_ones[l] = zipped[l][1];
              raw_ones[l] = zipped[l][2];
              cl_list[l] = zipped[l][3];
              prob_list[l] = zipped[l][4];
            }

            console.log("Predicted ones", predicted_ones);
            console.log("Raw ones", raw_ones);
            console.log("Class", cl_list);
            console.log("Prob", prob_list);

          }

          // for(let i = 0; i < predicted_ones.length; i++){
          //   console.log(predicted_ones[i]);
          // }
          console.log("raw_ones", raw_ones);
          this.setState({
            raw_images: raw_ones,
            predicted_images: predicted_ones,
            classifications: cl_list,
            probabilities: prob_list,
            orig_names: names_list,
            show2: true,
          });
        },
        (error) => {
          console.log(error);
        }
      );
  }

  refreshPage() {
    window.location.href = "/";
  }

  triggerInputFile() {
    // this.setState({user: usr});
    this.fileInput.click();
    this.setState({
      show1: true,
    });
  }
  render() {
    // const { raw_images, predicted_images } = this.state;
    const biggerLead = {
      fontSize: 1.4 + "em",
      fontWeight: 200,
    };
    return (
      <div className="text-center">
        <div className="row justify-content-center">
          <div className="col-10">
            <div className="display-4 text-primary mt-3 mb-2">
              <img src={mySvg} width="100" height="100" alt="Mosquito-logo" />
              <br />
              Upload Images of Adult Mosquitoes Here
              <br />
            </div>
            <p className="lead" style={biggerLead}>
              Identifies whether{" "}
              <b>
                <i>Anopheles stephensi</i>
              </b>{" "}
              or not
            </p>
            <p className="lead" style={biggerLead}>
              You can upload up to 5 images and perform species classification
              on them
            </p>
            <p className="lead">
              <b>
                Please upload only JPEG, PNG or JPG images (<span style={{color: "red"}}>PDF, TIF, WEBP, and HEIC files are
                  not supported</span>).
              </b>
            </p>
            <div className="display-4 text-secondary"></div>
            <br />
            <button
              className="btn btn-outline-info mr-2"
              onClick={this.triggerInputFile.bind(this)}
              // onClick={() => alert("Cannot upload images at the moment. Please try again later.")}
            >
              <TiCloudStorageOutline size={30} />{" "}
              <h5>Choose images to upload </h5>
            </button>
            <br />
            <p className="text-secondary">
              {this.state.images.length} images are chosen.
            </p>{" "}
            {this.state.show1 ? (
              <p>Please select Upload to upload the images.</p>
            ) : null}
            <input
              type="file"
              ref={(fileInput) => (this.fileInput = fileInput)}
              multiple
              accept="image/*"
              onChange={this.handleChange.bind(this)}
              style={{ display: "none" }}
            />
            {this.state.show ? (
              <h6 className="text-secondary">
                Press on Classify to perform species classification on images or
                Clear to start over:
              </h6>
            ) : null}
            {!this.state.show ? (
              <button
                className="btn btn-outline-primary mr-2"
                onClick={this.handleUpload.bind(this)}
              >
                Upload
              </button>
            ) : null}
            {this.state.show ? (
              <button
                className="btn btn-outline-info mr-2"
                onClick={this.getClassifiedImage.bind(this)}
              >
                Classify
              </button>
            ) : null}
            {this.state.show ? (
              <button
                className="btn btn-outline-warning mr-2"
                onClick={this.refreshPage.bind(this)}
              >
                Clear
              </button>
            ) : null}
            <br />
            <br />
            <ProgressBar
              animated
              now={this.state.progress}
              label={`${this.state.progress}%`}
              min="0"
              max="100"
            ></ProgressBar>
            <br />
            <h3 className="text-secondary">
              Images will appear below (classification might take up to a minute
              per image):
            </h3>
            {/* <br /> */}
            {/* <FormError theMessage={"Due to Hurricane Ian, our servers are shut down for safety reasons. They will be back up early next week. Please excuse the inconvenience."} /> */}
          </div>
        </div>
        <Container>
          <Row>
            <Col xs="6" md={6}>
              {this.state.show ? (
                <h4 className="text-secondary">Uploaded images:</h4>
              ) : null}


              <a href={this.state.raw_images[0]} target="#">
                <Image src={this.state.raw_images[0]} thumbnail />
              </a>
              {/* image name */}
              {this.state.show2 && this.state.orig_names[0] !== undefined ? (
                <FormFilled theMessage={this.state.orig_names[0]} />
              ) : null}
            </Col>
            <Col xs="6" md={6}>
              {this.state.show ? (
                <h4 className="text-secondary">Classified images:</h4>
              ) : null}

              <a href={this.state.predicted_images[0]} target="#">
                <Image src={this.state.predicted_images[0]} thumbnail />
              </a>
              {/* image name */}
              {this.state.show2 &&
              this.state.classifications[0] !== undefined &&
              this.state.probabilities[0] !== undefined ? (

                    <FormFilled theMessage={this.state.classifications[0] + ": " + this.state.probabilities[0] + "%"}/>

              ) : null}
            </Col>
          </Row>
          <br/>
          <Row>
            <Col xs="6" md={6}>

              <a href={this.state.raw_images[1]} target="#">
                <Image src={this.state.raw_images[1]} thumbnail />
              </a>
              {this.state.show2 && this.state.orig_names[1] !== undefined ? (
                <FormFilled theMessage={this.state.orig_names[1]}/>
              ) : null}
            </Col>
            <Col xs="6" md={6}>

              <a href={this.state.predicted_images[1]} target="#">
                <Image src={this.state.predicted_images[1]} thumbnail />
              </a>
              {this.state.show2 &&
              this.state.classifications[1] !== undefined &&
              this.state.probabilities[1] !== undefined ? (
                <FormFilled theMessage={this.state.classifications[1] + ": " + this.state.probabilities[1] + "%"}/>

              ) : null}
            </Col>
          </Row>
          <br/>
          <Row>
            <Col xs="6" md={6}>

              <a href={this.state.raw_images[2]} target="#">
                <Image src={this.state.raw_images[2]} thumbnail />
              </a>
              {this.state.show2 && this.state.orig_names[2] !== undefined ? (
                <FormFilled theMessage={this.state.orig_names[2]}/>
              ) : null}
            </Col>
            <Col xs="6" md={6}>

              <a href={this.state.predicted_images[2]} target="#">
                <Image src={this.state.predicted_images[2]} thumbnail />
              </a>
              {this.state.show2 &&
              this.state.classifications[2] !== undefined &&
              this.state.probabilities[2] !== undefined ? (
                <FormFilled theMessage={this.state.classifications[2] + ": " + this.state.probabilities[2] + "%"}/>

              ) : null}
            </Col>
          </Row>
          <br/>
          <Row>
            <Col xs="6" md={6}>

              <a href={this.state.raw_images[3]} target="#">
                <Image src={this.state.raw_images[3]} thumbnail />
              </a>
              {this.state.show2 && this.state.orig_names[3] !== undefined ? (
                <FormFilled theMessage={this.state.orig_names[3]}/>
              ) : null}
            </Col>
            <Col xs="6" md={6}>

              <a href={this.state.predicted_images[3]} target="#">
                <Image src={this.state.predicted_images[3]} thumbnail />
              </a>
              {this.state.show2 &&
              this.state.classifications[3] !== undefined &&
              this.state.probabilities[3] !== undefined ? (
                <FormFilled theMessage={this.state.classifications[3] + ": " + this.state.probabilities[3] + "%"}/>

              ) : null}
            </Col>
          </Row>
          <br/>
          <Row>
            <Col xs="6" md={6}>

              <a href={this.state.raw_images[4]} target="#">
                <Image src={this.state.raw_images[4]} thumbnail />
              </a>
              {this.state.show2 && this.state.orig_names[4] !== undefined ? (
                <FormFilled theMessage={this.state.orig_names[4]}/>
              ) : null}
            </Col>
            <Col xs="6" md={6}>

              <a href={this.state.predicted_images[4]} target="#">
                <Image src={this.state.predicted_images[4]} thumbnail />
              </a>
              {this.state.show2 &&
              this.state.classifications[4] !== undefined &&
              this.state.probabilities[4] !== undefined ? (
                <FormFilled theMessage={this.state.classifications[4] + ": " + this.state.probabilities[4] + "%"}/>

              ) : null}
            </Col>
          </Row>
          {/* <Row>
            <Col xs="6" md={6}>
              <a href={this.state.raw_images[5]} target="#">
                <Image src={this.state.raw_images[5]} thumbnail />
              </a>
            </Col>
            <Col xs="6" md={6}>
              <a href={this.state.predicted_images[5]} target="#">
                <Image src={this.state.predicted_images[5]} thumbnail />
              </a>
            </Col>
          </Row>
          <Row>
            <Col xs="6" md={6}>
              <a href={this.state.raw_images[6]} target="#">
                <Image src={this.state.raw_images[6]} thumbnail />
              </a>
            </Col>
            <Col xs="6" md={6}>
              <a href={this.state.predicted_images[6]} target="#">
                <Image src={this.state.predicted_images[6]} thumbnail />
              </a>
            </Col>
          </Row>
          <Row>
            <Col xs="6" md={6}>
              <a href={this.state.raw_images[7]} target="#">
                <Image src={this.state.raw_images[7]} thumbnail />
              </a>
            </Col>
            <Col xs="6" md={6}>
              <a href={this.state.predicted_images[7]} target="#">
                <Image src={this.state.predicted_images[7]} thumbnail />
              </a>
            </Col>
          </Row>
          <Row>
            <Col xs="6" md={6}>
              <a href={this.state.raw_images[8]} target="#">
                <Image src={this.state.raw_images[8]} thumbnail />
              </a>
            </Col>
            <Col xs="6" md={6}>
              <a href={this.state.predicted_images[8]} target="#">
                <Image src={this.state.predicted_images[8]} thumbnail />
              </a>
            </Col>
          </Row>
          <Row>
            <Col xs="6" md={6}>
              <a href={this.state.raw_images[9]} target="#">
                <Image src={this.state.raw_images[9]} thumbnail />
              </a>
            </Col>
            <Col xs="6" md={6}>
              <a href={this.state.predicted_images[9]} target="#">
                <Image src={this.state.predicted_images[9]} thumbnail />
              </a>
            </Col>
          </Row> */}
        </Container>
      </div>
    );
  }
}

export default UploadImages;
